import { useDispatch, useSelector } from "react-redux";
import {
  resetInitialState,
  setIsModalShown,
  setLanguage,
} from "../../redux/globalFunctions";
import { resetForm } from "../../redux/companyForm";
import { resetAnswers } from "../../redux/answers";
import { resetAnsweredQuestions } from "../../redux/answeredQuestions";
import translations from "../../en.json";
import translationsNo from "../../no.json";

export function Modal() {
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.global);

  function resetQuiz() {
    dispatch(setIsModalShown(false));
    dispatch(resetInitialState());
    dispatch(resetForm());
    dispatch(resetAnswers());
    dispatch(resetAnsweredQuestions());
    dispatch(setLanguage(language));
  }

  const modalText =
    language === "en" ? translations.modal : translationsNo.modal;

  return (
    <div className="overlay" id="popupOverlay">
      <div className="popup">
        <p className="quiz-title">{modalText.title}</p>
        <p className="quiz-description">{modalText.description}</p>
        <button
          className="continue"
          onClick={() => dispatch(setIsModalShown(false))}
        >
          {modalText.buttons?.continue}
        </button>
        <button className="cancel" onClick={resetQuiz}>
          {modalText.buttons?.cancel}
        </button>
      </div>
    </div>
  );
}
